import { useState } from "react";
import { View } from "react-native";
import { VDBText } from "..";
import { useTypographyStore } from "@redux/slices/typographySlice";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import { VDBIcons } from "@utils/VDBIcons";
import { useTheme } from "styled-components/native";
import { LinearGradient } from "expo-linear-gradient";
import { useGradientFromValue } from "../../../hooks/useThemedGradient";
import { useSelector } from "react-redux";

type WebActionButtonProps = {
  bulkButtonText: string;
  id: string;
};

const WebActionButton = ({ bulkButtonText, id }: WebActionButtonProps) => {
  const theme = useTheme();
  const typography = useTypographyStore();
  const [hovered, setHovered] = useState(false);
  const enableGradient = useSelector(
    (state: any) => state.globalData?.app_settings?.enable_gradient
  );
  const currentBgToken = hovered ? "primary-bg-hover" : "primary-bg-static";
  const bgValue = theme[currentBgToken] as string;
  const fallbackColor = theme["core-01"] as string;
  const gradient = useGradientFromValue(bgValue, fallbackColor);

  return (
    <View
      id={id}
      onHoverIn={() => setHovered(true)}
      onHoverOut={() => setHovered(false)}
      style={{
        position: "relative",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "nowrap",
        borderRadius: 24,
        padding: 4,
        paddingHorizontal: 12,
        gap: 8,
        ...(!enableGradient && {
          backgroundColor: bgValue,
        }),
        overflow: "hidden",
      }}
    >
      {enableGradient && (
        <LinearGradient
          colors={gradient.colors as [string, string, ...string[]]}
          start={gradient.start}
          end={gradient.end}
          locations={gradient.locations as [number, number, ...number[]]}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            borderRadius: 24,
          }}
        />
      )}
      <VDBText
        color={theme["primary-cont"]}
        type={typography["Body-M"]}
        style={{ overflow: "hidden" }}
      >
        {bulkButtonText}
      </VDBText>
      <VDBIcon
        color={theme["primary-cont"]}
        size={24}
        variant={IconsVariant.VDBCustom}
        name={VDBIcons.ADD_CIRCLE}
      />
    </View>
  );
};

export default WebActionButton;
